import Vue from "vue";
import firebase from "firebase";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import MaterialKit from "./plugins/material-kit";

Vue.config.productionTip = false;

Vue.use(MaterialKit);

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

let app = ``;

const config = {
  apiKey: "AIzaSyDDVkATKvVvWanyaZfy90_lDuzKhYbYXqU",
  authDomain: "dearfuture-dev.firebaseapp.com",
  databaseURL: "https://dearfuture-dev.firebaseio.com",
  projectId: "dearfuture-dev",
  storageBucket: "dearfuture-dev.appspot.com",
  messagingSenderId: "109714084453",
  appId: "1:109714084453:web:eb505a03f2679337992c8c",
  measurementId: "G-BC3FPRNNYC"
};

firebase.initializeApp(config);
firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);

  if (!app) {
    new Vue({
      el: "#app",
      router,
      store,
      render: h => h(App)
    });
  }
});
